import { render, staticRenderFns } from "./complex-table3.vue?vue&type=template&id=2a2a9c73"
import script from "./complex-table3.vue?vue&type=script&lang=js"
export * from "./complex-table3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports